import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' ? 'http://localhost:3001/api' : '/api');

// timeout 必须设：无超时时，被代理/网络黑洞掉的请求会永远 pending，
// 上层 .finally 永不触发 → 加载动画无限转（如 hub 场次面板卡死）。
// 到点自动 reject(ECONNABORTED) → 走 .catch 显示错误态、可重试。
const api = axios.create({ baseURL: API_BASE, timeout: 20000 });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
